import { useEffect } from 'react';
import { parseText } from '../../utils/string/parseText';
import { useTranslation } from '../../hooks/useTranslation';

type CookiePolicy = {
  description: string[];
  heading: string;
  links?: string[];
};

export const CookiePolicyPage = () => {
  const { locale, data } = useTranslation();

  useEffect(() => {
    const previousWrapper = window.OptanonWrapper;
    window.OptanonWrapper = () => {
      previousWrapper?.();
      window.OneTrust?.initializeCookiePolicyHtml?.();
    };

    if (window.OneTrust) {
      window.OneTrust?.initializeCookiePolicyHtml?.();
    }

    return () => {
      window.OptanonWrapper = previousWrapper;
    };
  }, []);

  useEffect(() => {
    if (!locale || !window.OneTrust) return;

    // OneTrust expects ISO 639-1 language codes (e.g. "it"), not BCP 47 (e.g. "it-IT")
    const language = locale.split('-')[0];
    const changeLanguage = window.OneTrust.changeLanguage?.(language);
    const init = () => window.OneTrust?.initializeCookiePolicyHtml?.(true);

    if (window.OneTrust.changeLanguage && changeLanguage) {
      changeLanguage.then(init);
    }

    init();
  }, [locale]);

  if (!data) return null;

  return (
    <div className="w-11/12 md:max-w-[75%] mx-auto grid grid-cols-12 *:col-span-12">
      <h1 className="text-h4 mt-space-600 mb-space-300">{data.cookiePolicy?.title}</h1>

      <h2 className="text-h6 mt-space-300 mb-space-300">
        {data.cookiePolicy?.sections?.[0].heading}
      </h2>
      <p>{data.cookiePolicy?.sections?.[0]?.description}</p>

      <div id="ot-sdk-cookie-policy"></div>

      {data.cookiePolicy?.sections.slice(1).map((section: CookiePolicy, index) => (
        <section key={index} className="mb-space-600">
          <h6 className="text-h6 mt-space-300 mb-space-300">{section.heading}</h6>
          {section.description.map((paragraph, pIndex) => (
            <p key={pIndex} className="mb-space-300">
              {parseText(paragraph, section.links ?? [])}
            </p>
          ))}
        </section>
      ))}
    </div>
  );
};
